module.exports = () => {
  return {
    payments: [],
    offers: [],
    marketplace: [],
    rewards: [],
    favLocs: [],
    favOrders: [],
    addresses: [],
    signUpOptions: {},
    challenges: [],
    redeemables: [],
    badges: [],
  }
}